import React from 'react';

const Tile = ({ className = '', children, ...props }) => {
  return (
    <div
      className={`bg-white rounded-2xl shadow-[0_2px_10px_-3px_rgba(6,81,237,0.1)] border border-gray-100/50 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Tile;
